<div class="field">
  <app-form-edit-field-label
    #label
    fieldName="Text"
    [fieldType]="fieldTypes.TEXTBLOCK"
    [(data)]="data.label"></app-form-edit-field-label>
</div>
